export default __webpack_public_path__ + "images/AC.baf4b84.png";